<template>
  <div class="modal-content">
    <b-input class="spinbutton-pentagro mb-3" id="jsonDescription" v-model="filter" placeholder="Filtrar por nome..." />
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Ano</th>
          <th>Descrição</th>
          <th>Versão</th>
          <th>Data da Revisão</th>
          <th>Ver Plano</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="plan in filteredPlans" :key="plan.id">
          <td>{{ plan.baseYear }}</td>
          <td :class="plan.isBase ? 'destaque-base' : ''">{{ plan.description }}
            <span v-if="plan.isBase"><img class="img-cadeado" src="@/assets/cadeado.png" /></span>
          </td>
          <td>
            <center>{{ plan.planData.versionNumber }}</center>
          </td>
          <td>{{ plan.planData.revision }}</td>
          <td>
            <img src="@/assets/view.png" :alt="$t('visualizar-planejamento')" class="btn btn-link"
              :title="$t('visualizar-planejamento')" @click="viewPlan(plan)" />
          </td>
        </tr>
      </tbody>
    </table>
    <div class="modal-footer">
      <img src="@/assets/sair.png" :alt="$t('fechar')" class="btn-close" :title="$t('fechar')"
        @click="() => this.$bvModal.hide('viewReviewsPlan')" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalReviewsPlans",
  props: {
    plans: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      filter: "",
      json: []
    };
  },
  computed: {
    filteredPlans() {
      return this.plans.filter(plan =>
        plan.description.toLowerCase().includes(this.filter.toLowerCase())
      );
    }
  },
  methods: {
    viewPlan(plan) {
      this.$emit("view-plan", plan);
      this.$bvModal.hide('viewReviewsPlan')
    },
  },
};
</script>

<style scoped>
.modal-content {
  background-color: #fff;
  border-radius: 0.3rem;
  padding: 15px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dee2e6;
}

.table th,
.table td {
  vertical-align: middle;
}

.btn-close {
  cursor: pointer;
  margin-left: 30px;
  height: 40px;
}

.btn-link {
  margin-left: 30px;
  height: 30px;
  text-decoration: none;
}

.destaque-base {
  font-weight: bold;
}

.img-cadeado {
  height: 25px;
  width: 25px;
}

.btn-link:hover {
  text-decoration: underline;
}
</style>
